import React, { Fragment, useCallback, useEffect, useState, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { ThemeContext } from '~/web-frontend-components/context/AppContexts';
import { TBody } from '~/web-frontend-components/line/outcomes.mobile/additional/tables/TBody.mobile';
import { LOCK_STATE, STATE } from '~/web-frontend-core/api/const/base';
import { sendLogKafka, Events } from '~/web-frontend-components/helpers/kafka';
import Timer from '~/web-frontend-components/line/Timer';
const sportsInfographic = {
    26: 'Soccer',
    27: 'IceHockey',
    28: 'Basketball',
    33: 'Tennis',
    41: 'Volleyball',
    134: 'TableTennis',
    235: 'Badminton',
    337: 'BeachVolleyball',
    542: 'ShortHockey',
    32: 'Handball',
    177: 'Futsal',
};
export const sportsIds = {
    26: 'Football',
    27: 'IceHockey',
    28: 'BasketBall',
    32: 'Handball',
    33: 'Tennis',
    46: 'BeachFootball',
    41: 'Volleyball',
    315: 'Waterpolo',
    134: 'TableTennis',
    173: 'HockeyWhithBoll',
    177: 'Futsal',
    235: 'Badminton',
    337: 'BeachVolleyball',
    // 562: 'CyberHockey',
    // 564: 'CyberBasketBall',
    // 571: 'CyberVolleyball',
    635: 'ShortHockey',
    702: 'BasketBall3v3',
    // 560: 'CyberFootball',
};
export const Match = withRouter((props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const isDarkTheme = useMemo(() => {
        return ThemeContext.useTheme().theme === 'Dark';
    }, []);
    const getCoef = (betID) => props.matchData && props.matchData.odds[betID] || {};
    //#region favorite
    const [isFavorite, favorite] = useState(props.handlers.isFavoriteMatch(props.matchID));
    useEffect(() => {
        favorite(props.handlers.isFavoriteMatch(props.matchID));
    }, [props.handlers.isFavoriteMatch(props.matchID)]);
    const favoriteMatch = useCallback((e) => {
        e.stopPropagation();
        if (!isFavorite) {
            sendLogKafka(Events.favoUrites, { eventId: props.matchID });
        }
        props.handlers.favoriteMatch(props.matchID, !isFavorite);
        favorite(props.handlers.isFavoriteMatch(props.matchID));
    }, [props.matchID, isFavorite]);
    //#endregion
    const onVideoClick = useCallback((e) => {
        e.stopPropagation();
        props.handlers.onVideoClick({
            id: Number(props.matchID),
            stats: props.matchData.hasMatchInfo,
            hasInfographics: props.matchData.hasInfographics,
            sid: Number(props.sportID),
            c1: props.matchData.team1,
            c2: props.matchData.team2,
            score: props.matchData.score,
            video_type: props.matchData.video || []
        });
        props.history.push(`${props.url}?active=video`);
    }, [props.matchID, props.matchData.hasMatchInfo]);
    const onInfographicsClick = (e) => {
        e.stopPropagation();
        sendLogKafka(Events.matchCenterViewed, { eventId: props === null || props === void 0 ? void 0 : props.matchID });
        props.history.push(`${props.url}?active=stats`);
        props.handlers.onInfographicsClick({
            id: Number(props.matchID),
            stats: props.matchData.hasMatchInfo,
            hasInfographics: props.matchData.hasInfographics,
            sid: Number(props.sportID),
            c1: props.matchData.team1,
            c2: props.matchData.team2,
            score: props.matchData.score,
            video_type: props.matchData.video || []
        });
    };
    const isCoefChoosen = (betID, oddID) => {
        return props.handlers.isCoefChoosen(props.matchID, betID, oddID);
    };
    const onCoefChoose = (oddID) => {
        props.handlers.onCoefChoose(oddID, props.matchID);
    };
    const oddsCount = typeof props.matchData.oddsCnt === 'number' ? props.matchData.oddsCnt : props.matchData.oddsCnt[props.width];
    const hasMatchData = oddsCount !== 0 || props.matchData.hasMatchInfo || props.matchData.video;
    const sportName = sportsIds === null || sportsIds === void 0 ? void 0 : sportsIds[props.sportID];
    const sScoreData = sportName && ((_a = props.matchData.sScore) === null || _a === void 0 ? void 0 : _a.sScoreData);
    const isFootballBased = sportName === 'Football' || sportName === 'Futsal' || sportName === 'BeachFootball'
        || sportName === 'CyberFootball';
    const isIceHockeyBased = sportName === 'IceHockey' || sportName === 'Waterpolo' || sportName === 'HockeyWhithBoll'
        || sportName === 'ShortHockey' || sportName === 'CyberHockey' || sportName === 'Handball';
    const isBasketBallBased = sportName === 'BasketBall' || sportName === 'BasketBall3v3'
        || sportName === 'CyberBasketBall';
    const isTennis = sportName === 'Tennis';
    const isTwoDvsBased = sportName === 'Volleyball' || sportName === 'TableTennis' || sportName === 'Badminton'
        || sportName === 'BeachVolleyball' || sportName === 'CyberVolleyball';
    const sScoreMain = (_b = sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.scs) === null || _b === void 0 ? void 0 : _b.filter(item => {
        if (isFootballBased) {
            return (item.et === 1);
        }
        if (isIceHockeyBased) {
            return (item.et === 1);
        }
        if (isBasketBallBased) {
            return (item.et === 101);
        }
        if (isTennis) {
            return (item.et === 100 || item.et === 99);
        }
        if (isTwoDvsBased) {
            return (item.et === 101 || item.et === 99);
        }
        return null;
    });
    const sScoreStatistic = (_c = sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.scs) === null || _c === void 0 ? void 0 : _c.filter(item => {
        if ((sportsIds === null || sportsIds === void 0 ? void 0 : sportsIds[props.sportID]) === 'Football') {
            return (item.et === 4);
        }
        if ((sportsIds === null || sportsIds === void 0 ? void 0 : sportsIds[props.sportID]) === 'Tennis') {
            return (item.et === 101);
        }
        return null;
    });
    const dontShowCurrentTime = isFootballBased;
    const sScoreStatisticViewConstructor = (team) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const teamNumber = team === 1 ? 't1' : 't2';
        if (!((_c = (_b = (_a = sScoreStatistic === null || sScoreStatistic === void 0 ? void 0 : sScoreStatistic[0]) === null || _a === void 0 ? void 0 : _a.scv) === null || _b === void 0 ? void 0 : _b.cur) === null || _c === void 0 ? void 0 : _c[teamNumber])) {
            return null;
        }
        if ((sportsIds === null || sportsIds === void 0 ? void 0 : sportsIds[props.sportID]) === 'Football') {
            if (((_f = (_e = (_d = sScoreStatistic === null || sScoreStatistic === void 0 ? void 0 : sScoreStatistic[0]) === null || _d === void 0 ? void 0 : _d.scv) === null || _e === void 0 ? void 0 : _e.cur) === null || _f === void 0 ? void 0 : _f[teamNumber]) === '0') {
                return null;
            }
            return (<div style={{
                    borderRadius: '2px',
                    background: '#E92934',
                    minWidth: '8px',
                    width: '12px',
                    padding: '2px',
                    color: '#FFFFFF'
                }}>
          {(_j = (_h = (_g = sScoreStatistic === null || sScoreStatistic === void 0 ? void 0 : sScoreStatistic[0]) === null || _g === void 0 ? void 0 : _g.scv) === null || _h === void 0 ? void 0 : _h.cur) === null || _j === void 0 ? void 0 : _j[teamNumber]}
        </div>);
        }
        if ((sportsIds === null || sportsIds === void 0 ? void 0 : sportsIds[props.sportID]) === 'Tennis') {
            return (<div style={{
                    borderRadius: '2px',
                    color: isDarkTheme ? '#D1D1D1' : '#747474',
                    background: isDarkTheme ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                }}>
          {(_m = (_l = (_k = sScoreStatistic === null || sScoreStatistic === void 0 ? void 0 : sScoreStatistic[0]) === null || _k === void 0 ? void 0 : _k.scv) === null || _l === void 0 ? void 0 : _l.cur) === null || _m === void 0 ? void 0 : _m[teamNumber]}
        </div>);
        }
        return null;
    };
    <div style={{
            borderRadius: '2px',
            background: 'rgba(0, 0, 0, 0.1)',
        }}>
    {(_f = (_e = (_d = sScoreStatistic === null || sScoreStatistic === void 0 ? void 0 : sScoreStatistic[0]) === null || _d === void 0 ? void 0 : _d.scv) === null || _e === void 0 ? void 0 : _e.cur) === null || _f === void 0 ? void 0 : _f.t1}
  </div>;
    return <div className="live__item__game">
    <div className="live__item__game-info-live emprty" onClick={hasMatchData ? () => {
            sendLogKafka(Events.eventViewed, { eventId: props.matchID });
            props.history.push(props.url);
        } : void 0}>
      <div className="live__item__game__header">
        {sScoreData ? <span className="live__item__game__header__state">
          {sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.sd}
        </span> : ''}
        {(sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.fpss) ? <div className="live__item__game__body__fpss">
          {sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.fpss}
        </div> : ''}
        {!sScoreData ? <div className="live__item__game__body__fpss">
          {props.matchData.score}
        </div> : ''}
        <Timer t={sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.t} deltaTimeMs={props.deltaTimeMs}/>
        <VideoChannels video={props.matchData.video} url={props.url} onClick={onVideoClick}/>
        <Infographics hasMatchInfo={props.matchData.hasMatchInfo === STATE.ENABLED} hasInfographics={props.matchData.hasInfographics === STATE.ENABLED} url={props.url} onClick={onInfographicsClick} sportId={props.sportID}/>
        <Toggle count={oddsCount} url={props.url}/>
        <div className="live__item__game__fav">
          <div onClick={favoriteMatch}>
            <i style={{ fontSize: '16px', }} className={`${isFavorite ? 'f-s-ico-star_selected' : 'f-s-ico-star'}`}>
            </i>
          </div>
        </div>
      </div>
      <div className="live__item__game__body">
        <div className="live__item__game__body__teamInfo">
          <div className="live__item__game__body__teamInfo__teamName">
            {props.matchData.team1}
          </div>
          <div className="live__item__game__body__teamInfo__sScore">
            {(sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.s) === 1 ? <div className={`sportTextColor-${props.sportID}`}>◎</div> : ''}
            {sScoreStatisticViewConstructor(1)}
            {sScoreMain && (sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain.length) > 1 && !dontShowCurrentTime
            ? <div style={{ color: '#5580E3' }}>
                {(_j = (_h = (_g = sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain[(sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain.length) - 1]) === null || _g === void 0 ? void 0 : _g.scv) === null || _h === void 0 ? void 0 : _h.cur) === null || _j === void 0 ? void 0 : _j.t1}
              </div>
            : ''}
            <div>{(_m = (_l = (_k = sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain[0]) === null || _k === void 0 ? void 0 : _k.scv) === null || _l === void 0 ? void 0 : _l.cur) === null || _m === void 0 ? void 0 : _m.t1}</div>
          </div>
        </div>
        <div className="live__item__game__body__teamInfo">
          <div className="live__item__game__body__teamInfo__teamName">
            {props.matchData.team2}
          </div>
          <div className="live__item__game__body__teamInfo__sScore">
            {(sScoreData === null || sScoreData === void 0 ? void 0 : sScoreData.s) === 2 ? <div className={`sportTextColor-${props.sportID}`}>◎</div> : ''}
            {sScoreStatisticViewConstructor(2)}
            {sScoreMain && (sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain.length) > 1 && !dontShowCurrentTime
            ? <div style={{ color: '#5580E3' }}>
                {(_q = (_p = (_o = sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain[(sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain.length) - 1]) === null || _o === void 0 ? void 0 : _o.scv) === null || _p === void 0 ? void 0 : _p.cur) === null || _q === void 0 ? void 0 : _q.t2}
              </div>
            : ''}
            <div>{(_t = (_s = (_r = sScoreMain === null || sScoreMain === void 0 ? void 0 : sScoreMain[0]) === null || _r === void 0 ? void 0 : _r.scv) === null || _s === void 0 ? void 0 : _s.cur) === null || _t === void 0 ? void 0 : _t.t2}</div>
          </div>
        </div>
      </div>
    </div>

    {props.matchData.mainTable ?
            <TBody {...{
                highlightChanges: props.highlightChanges,
                isCoefChoosen,
                onCoefChoose: onCoefChoose,
                matchID: props.matchID,
                disabled: props.matchData.bl === LOCK_STATE.BLOCKED,
                getCoef,
                rows: props.matchData.mainTable,
            }}/> : <div style={{ height: '8px' }}></div>}
  </div>;
});
const Toggle = React.memo((props) => <div className="live__item__game-ross">
    {props.count !== 0 &&
        <a>
        {`+${props.count}`}
        {/* <i className="f-s-ico-arrow_right_1" />&nbsp; */}
      </a>}
  </div>);
const Infographics = React.memo((props) => {
    if ((props.hasInfographics && sportsInfographic[props === null || props === void 0 ? void 0 : props.sportId]) || props.hasMatchInfo) {
        return <div className="g-tv fl_r">
      <span style={{ fontSize: '18px' }} className="f-s-ico-infographics" onClick={props.onClick}/>
    </div>;
    }
    return null;
});
const VideoChannels = React.memo((props) => {
    if (!props.video) {
        return null;
    }
    return <Fragment>{props.video.map((linkType) => <div className="live__item__game__video" key={linkType}>
        <div style={{
                display: 'flex',
                alignItems: 'center',
                height: '16px',
            }} className="g-tv">
          <a style={{ fontSize: '20px' }} className={`item-ico-video f-s-ico-icon_live_tv item-ico-video-type-${linkType}`} onClick={props.onClick}>
          </a>
        </div>
      </div>)}</Fragment>;
});



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/matches.mobile/list/sport/championship/Match.jsx